/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubmissionSizeDiagnostics } from './SubmissionSizeDiagnostics';
import {
    SubmissionSizeDiagnosticsFromJSON,
    SubmissionSizeDiagnosticsFromJSONTyped,
    SubmissionSizeDiagnosticsToJSON,
    SubmissionSizeDiagnosticsToJSONTyped,
} from './SubmissionSizeDiagnostics';
import type { SubmissionProviderDiagnostic } from './SubmissionProviderDiagnostic';
import {
    SubmissionProviderDiagnosticFromJSON,
    SubmissionProviderDiagnosticFromJSONTyped,
    SubmissionProviderDiagnosticToJSON,
    SubmissionProviderDiagnosticToJSONTyped,
} from './SubmissionProviderDiagnostic';
import type { SpeciesCandidate } from './SpeciesCandidate';
import {
    SpeciesCandidateFromJSON,
    SpeciesCandidateFromJSONTyped,
    SpeciesCandidateToJSON,
    SpeciesCandidateToJSONTyped,
} from './SpeciesCandidate';

/**
 * What the reply flow wrote to prediction.json — the stages the DB row
 * doesn't keep (detector hit, classifier top-N, consensus reasoning).
 * Lenient on purpose: the file is a corpus record, not an API contract.
 * @export
 * @interface SubmissionDiagnostics
 */
export interface SubmissionDiagnostics {
    /**
     * 
     */
    segmentationFound?: boolean | null;
    /**
     * 
     */
    species?: Array<SpeciesCandidate>;
    /**
     * 
     */
    sizeEstimates?: { [key: string]: SubmissionProviderDiagnostic; };
    /**
     * 
     */
    size?: SubmissionSizeDiagnostics | null;
}

/**
 * Check if a given object implements the SubmissionDiagnostics interface.
 */
export function instanceOfSubmissionDiagnostics(value: object): value is SubmissionDiagnostics {
    return true;
}

export function SubmissionDiagnosticsFromJSON(json: any): SubmissionDiagnostics {
    return SubmissionDiagnosticsFromJSONTyped(json, false);
}

export function SubmissionDiagnosticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionDiagnostics {
    if (json == null) {
        return json;
    }
    return {
        
        'segmentationFound': json['segmentation_found'] === undefined ? undefined : json['segmentation_found'] === null ? null : json['segmentation_found'],
        'species': json['species'] == null ? undefined : ((json['species'] as Array<any>).map(SpeciesCandidateFromJSON)),
        'sizeEstimates': json['size_estimates'] == null ? undefined : (mapValues(json['size_estimates'], SubmissionProviderDiagnosticFromJSON)),
        'size': json['size'] === undefined ? undefined : json['size'] === null ? null : SubmissionSizeDiagnosticsFromJSON(json['size']),
    };
}

export function SubmissionDiagnosticsToJSON(json: any): SubmissionDiagnostics {
    return SubmissionDiagnosticsToJSONTyped(json, false);
}

export function SubmissionDiagnosticsToJSONTyped(value?: SubmissionDiagnostics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'segmentation_found': value['segmentationFound'],
        'species': value['species'] == null ? undefined : ((value['species'] as Array<any>).map(SpeciesCandidateToJSON)),
        'size_estimates': value['sizeEstimates'] == null ? undefined : (mapValues(value['sizeEstimates'], SubmissionProviderDiagnosticToJSON)),
        'size': SubmissionSizeDiagnosticsToJSON(value['size']),
    };
}

